import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "primereact/button";
import { logout } from "utils/common";
import { connect } from "react-redux";

const AccessDenied = () => {
  const history = useHistory();

  const onLogoutClick = async () => {
    await logout(false);
    history.push("/login");
  };

  return (
    <div className="layout-wrapper">
      <img
        src="/hfn-logo-black.svg"
        height="120"
        width="200"
        alt="Logo-rth mb-3"
      />
      <div className="d-flex flex-column align-items-center">
        <p>
          Your profile doesnt&apos;have required permission. Please contact
          administrator.
        </p>

        <div className="proceed-btn">
          <Button
            label="Login with another Account"
            className="primary-btn mx-4"
            onClick={onLogoutClick}
          />
        </div>
        <small className="mt-4">
          <b>
            Note: Clicking on &quot;Login with another Account&quot; will log
            you out from all Heartfulness sites.
          </b>
        </small>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  ld: state.loginDetails,
});

export default connect(mapStateToProps)(AccessDenied);
